/**
 * 随前端发布的 WTK Luxury Standards 报告（客户版 JSON，schema_version 5.x，只含扣分项，见
 * 交付资料「Handoff - Luxury Standards / 02 前端说明」和 ../README.md）。
 *
 * 后端接口还没有，数据提供方按约定导出一份 JSON，放在这个目录、在下面登记一行，
 * 这家酒店就能打开 /QualityStandards 看新版页面（featureGates.js 读 LUXURY_STANDARDS_LOCAL_HOTELS）。
 * 文件用 import() 按需加载，打成单独的 chunk，不进主包。
 *
 * 这些文件只含本期被扣分的标准（findings）、扣分证据、建议和部门，不含完整标准目录、编号或
 * LQA / Forbes / 米其林映射；换新文件前先用交付资料里的 Schema（customer-report.v5.5.schema.json）校验。
 *
 * match：当前酒店名里包含这个片段（不分大小写）就用这份报告，和 featureGates.js 的
 * HOTEL_ONLY_PATHS 同一种宽松匹配（后端酒店名可能带城市 / 分店后缀）。也可以是一组都要命中的片段，
 * "!" 开头的片段是名字里不能有的（["InterContinental Bangkok", "!Sukhumvit"]）。
 */
export const LOCAL_LUXURY_REPORTS = [
  // W Shanghai - The Bund · 2026-10-01 — 2026-10-31（2026-11-02 换成 77 家酒店 10 月批次 r14，schema 5.5，英文；
  // 之前是 7/1–10/25 的 r5）
  {
    match: "W Shanghai",
    load: () => import(/* webpackChunkName: "guest-insights-w-shanghai" */ "./w_shanghai_2026-10_r14.en.v5.json"),
  },
  // InterContinental Bangkok · 2026-09-01 — 2026-10-31（2026-11-03，IHG 两家酒店批次 r14，schema 5.5，英文）。
  // 排除 Sukhumvit：那是另一家 InterContinental Bangkok Sukhumvit
  {
    match: ["InterContinental Bangkok", "!Sukhumvit"],
    load: () => import(/* webpackChunkName: "guest-insights-ic-bangkok" */ "./intercontinental_bangkok_2026-09-10_r14.en.v5.json"),
  },
  // InterContinental Phuket Resort · 2026-09-01 — 2026-10-31（同一批次）
  {
    match: "InterContinental Phuket",
    load: () => import(/* webpackChunkName: "guest-insights-ic-phuket" */ "./intercontinental_phuket_2026-09-10_r14.en.v5.json"),
  },
  // 正式环境（main）开 W Shanghai（2026-11-02）和上面两家 InterContinental（2026-11-03）；The Sanya EDITION、演示酒店 Grand Luxury 的新版只在 staging（dev）
];

/** 有本地报告的酒店名片段：featureGates.js 用来放行菜单和路由 */
export const LUXURY_STANDARDS_LOCAL_HOTELS = LOCAL_LUXURY_REPORTS.map((r) => r.match);

/** 酒店名是否命中 match（一个片段，或一组都要命中的片段；"!" 开头的是名字里不能有的） */
export function matchesHotelName(match, hotelName) {
  const name = String(hotelName || "").toLowerCase();
  if (!name) return false;
  return [].concat(match).every((frag) => {
    const f = String(frag).toLowerCase();
    return f.startsWith("!") ? !name.includes(f.slice(1)) : name.includes(f);
  });
}

/** 当前酒店有本地报告就返回报告对象，没有返回 null */
export async function loadLocalLuxuryReport(hotelName) {
  const hit = LOCAL_LUXURY_REPORTS.find((r) => matchesHotelName(r.match, hotelName));
  if (!hit) return null;
  const mod = await hit.load();
  return mod.default || mod;
}
